<template>
  <div class="block-xiaolu">
    <div class="content">
      <div class="one"><span class="txt">日/历史综合效率</span><span class="val">{{xlData.v1}}</span></div>
      <div class="two"><span class="txt">电站运行天数</span><span class="val">{{xlData.v2}}天</span></div>
    </div>
  </div>
</template>

<script>
  import API from '@/api/svolt/project';
export default {
  props: {
    data: {
      type: [Object, Array]
    },
    height: {
      style: Number
    },
    type: {
      type: [Number, String],
      default: 1 //默认第一种
    }
  },
  data() {
    return {
    xlData:{
      v1:'',
      v2:''
    }
    };
  },
  methods: {
    searchEnergyStorageChargeAndDischargeEfficiency(){
      API.searchEnergyStorageChargeAndDischargeEfficiency({projectId:this.$route.query.projectId}).then(res=>{
        if(res.data.code==200){
          let d = res.data.data
          this.xlData.v1 = d.dailyEfficiency+'/'+d.totalEfficiency
          this.xlData.v2 = d.runDays
        }
      })
    }
  },
  created() {
    this.searchEnergyStorageChargeAndDischargeEfficiency()
  },
  mounted() {}
};
</script>

<style lang="scss">
.block-xiaolu {
  width: 428px;
  height: 147px;
  display: inline-block;
  background: url('/static/images/svolt/nanwang/block-guimo-bj.png') no-repeat;
  background-size: 100%;
  margin-left: -6px;
  margin-top: 5px;
  .content{
    width:100%;
    height:100%;
    position: relative;
    background: url('/static/images/svolt/nanwang/nengxiao-item-bj.png') no-repeat;
    background-position: center;
    .txt{
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #5E688F;
      margin-left:120px;
      display:inline-block;
      width:115px;
    }
    .val{
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #08265F;
      display:inline-block;
    }
    .one{
      height:80px;
      line-height:80px;
    }
    .two{
      height:45px;
      line-height:45px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/block-xiaolu.vue